import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"icon-account\"><path d=\"M10.4 12.8A6.4 6.4 0 1 0 4 6.4a6.408 6.408 0 0 0 6.4 6.4Zm0-11.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Zm4.8 12H5.6A5.606 5.606 0 0 0 0 19.2a.8.8 0 0 0 .8.8H20a.8.8 0 0 0 .8-.8 5.606 5.606 0 0 0-5.6-5.6ZM1.68 18.4a4.006 4.006 0 0 1 3.92-3.2h9.6a4.007 4.007 0 0 1 3.92 3.2H1.68Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol